export const CHECKOUT_URL = 'https://metodofutbol.impultienda.ar/checkout';
export const stats = [{
  value: "12 +2",
  label: "Capítulos y Bonos"
}, {
  value: '+140',
  label: 'Páginas en PDF'
}, {
  value: '100%',
  label: 'Contexto argentino'
}, {
  value: "∞",
  label: 'Acceso de por vida'
}];
export const heroTestimonials = [{
  quote: 'Antes no entendía nada de pases, derechos ni cómo elegir un representante. Ahora sé cómo moverme, qué preguntar y cómo proteger a mi hijo en cada paso de su carrera.',
  name: 'Marcelo G.',
  role: 'Padre de futbolista juvenil, Buenos Aires'
}, {
  quote: 'Me ayudó a entender cómo funciona el sistema desde adentro. Tomé mejores decisiones en el cambio de club de mi hijo. También me ayudó a reconocer la presión psicológica que sufría y cómo acompañarlo mejor emocionalmente.',
  name: 'Marina P.',
  role: 'Madre de futbolista sub-15, Córdoba'
}];
export const problems = ['Tu hijo no juega y no sabés cómo hablarlo con el club. Pensás en cambiarlo, pero no sabés cuándo ni cómo hacerlo.', 'Te aparecen "scouts" o "representantes" y no sabés si son reales o te están usando.', 'No sabés qué revisar antes de firmar un contrato o acuerdo con un club.', 'Te llegó una "oportunidad" del exterior y no sabés si es real o es una estafa.', 'No conocés los derechos de tu hijo como jugador menor en el fútbol argentino.', 'Querés acompañar la carrera de tu hijo pero no sabés por dónde empezar ni qué decisiones tomar.'];
export const chapters = [{
  number: '01',
  title: 'El Camino del Futbolista Argentino',
  description: 'Entendé cómo está organizado el fútbol juvenil en Argentina: AFA, ligas, clubes, categorías, etapas del jugador y el rol del padre en cada momento. Más un mapa de carrera de los 8 a los 18 años.',
  tags: ['AFA y Ligas', 'Etapas del jugador', 'Rol del padre', 'Fútbol y educación']
}, {
  number: '02',
  title: 'Clubes, Pases y Representantes',
  description: 'Aprendé cómo funciona un pase en Argentina, tipos de jugador (registrado, libre, préstamo, transferido), documentación, representantes, cómo verificarlos, qué firmar y qué nunca aceptar.',
  tags: ['Pases y registros', 'Cambio de club', 'Representantes', 'Señales de alerta']
}, {
  number: '03',
  title: 'Oportunidades, Pruebas y Fútbol en el Exterior',
  description: 'Cómo presentar a tu hijo profesionalmente, pruebas y trials, cómo evaluar invitaciones sospechosas, transferencias internacionales de menores, restricciones FIFA, becas.',
  tags: ['CV deportivo', 'Pruebas y trials', 'Fútbol en el exterior', 'Restricciones FIFA']
}, {
  number: '04',
  title: 'Derechos, Contratos y Desarrollo del Futbolista',
  description: 'Derechos del menor, mecanismo de solidaridad, primer contrato profesional, cláusulas a revisar, cuándo consultar abogado, salud, rendimiento, semáforo de riesgos, nutrición, psicología y neurociencia.',
  tags: ['Derechos del menor', 'Primer contrato', 'Cláusulas clave', 'Semáforo de riesgos']
}];
export const bonuses = [{
  number: 'Bono 01',
  title: 'KIT ANTI HUMO DEL PADRE DEL FUTBOLISTA',
  description: 'Plantillas y checklists para detectar estafas, evaluar representantes y revisar pruebas antes de decir que sí.',
  originalPrice: '$14.900'
}, {
  number: 'Bono 02',
  title: 'PLAN DE 30 DÍAS PARA ORDENAR LA CARRERA DE TU HIJO',
  description: '¿No sabés por dónde empezar? No te preocupes. Armamos un plan paso a paso para que en un mes tengas la carrera de tu hijo totalmente ordenada.',
  originalPrice: '$14.990'
}];
export const offerChecklist = ['12 CAPÍTULOS COMPLETOS', 'MÁS DE 140 PÁGINAS EN PDF', 'KIT ANTI HUMO DEL PADRE DEL FUTBOLISTA', 'PLAN DE 30 DÍAS PARA ORDENAR LA CARRERA DE TU HIJO', 'ACCESO INMEDIATO DE POR VIDA'];
export const testimonials = [{
  initials: 'MG',
  color: '#1d4ed8',
  quote: 'Antes no entendía nada de pases ni representantes. Ahora sé exactamente qué preguntar y cómo proteger a mi hijo.',
  name: 'Marcelo G.',
  role: 'Buenos Aires'
}, {
  initials: 'MP',
  color: '#b45309',
  quote: 'Me ayudó a entender cómo funciona el sistema desde adentro. Tomé mejores decisiones en el cambio de club de mi hijo. También me ayudó a reconocer la presión psicológica que sufría y cómo acompañarlo mejor emocionalmente.',
  name: 'Marina P.',
  role: 'Córdoba'
}, {
  initials: 'DF',
  color: '#15803d',
  quote: 'Cuando nos llamó un "representante", ya sabía qué preguntar. Gracias al Kit Anti Humo evité firmar algo que podría haberle complicado la carrera.',
  name: 'Diego F.',
  role: 'Rosario'
}, {
  initials: 'JL',
  color: '#7e22ce',
  quote: 'Lo tengo guardado en el celular y cada vez que aparece alguna situación con el club lo vuelvo a consultar. Me sirvió mucho para saber por dónde encarar las cosas.',
  name: 'Jorge L.',
  role: 'Mendoza'
}, {
  initials: 'RG',
  color: '#be123c',
  quote: 'La parte de derechos y contratos fue de las que más me sirvió. Había muchas cosas que desconocía y nunca me había puesto a pensar que mi hijo podía tener determinados derechos por ser menor.',
  name: 'Romina G.',
  role: 'Santa Fe'
}];
export const faqs = [{
  question: '¿Es adecuado si recién empiezo a entender el mundo del fútbol juvenil?',
  answer: 'Sí, está pensado exactamente para vos. Explica todo desde cero, con lenguaje claro y sin tecnicismos, adaptado al contexto argentino.'
}, {
  question: '¿Para qué categorías o edades sirve?',
  answer: 'Está orientado a padres de futbolistas desde las categorías infantiles hasta reserva y la firma del primer contrato profesional.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: '100% digital en PDF. No hay envíos. Accesible desde cualquier dispositivo.'
}, {
  question: '¿Cómo recibo mi compra?',
  answer: 'Inmediatamente después del pago recibís un email con el link de descarga.'
}, {
  question: '¿Tengo que pagar todos los meses?',
  answer: 'No. Es un pago único con acceso de por vida.'
}, {
  question: '¿Qué pasa si no estoy satisfecho?',
  answer: 'Tenés 7 días de garantía. Escribí a solucionesoinformacion@gmail.com.'
}, {
  question: '¿En qué se diferencia de buscar información gratis en internet?',
  answer: 'La información online está dispersa y no aplica al contexto argentino. Este método está organizado, verificado y listo para usar.'
}, {
  question: '¿Este ebook garantiza que mi hijo va a ser profesional?',
  answer: 'No. Está diseñado para que como padre puedas acompañar y proteger la carrera de tu hijo con información correcta.'
}];
export const comparisonRows = [{
  situation: 'Entender el sistema del fútbol juvenil',
  without: 'Confusión y desinformación',
  with: 'Estructura clara y completa'
}, {
  situation: 'Recibir una propuesta de representante',
  without: 'No sabés qué preguntar',
  with: 'Checklist de verificación listo'
}, {
  situation: 'Cambio de club o pase',
  without: 'El club siempre tiene más poder',
  with: 'Conocés tus derechos y cómo usarlos'
}, {
  situation: 'Oportunidad del exterior',
  without: 'No sabés si es real o una estafa',
  with: 'Sabés cómo evaluarla paso a paso'
}, {
  situation: 'Firmar un contrato',
  without: 'Firmás sin entender qué dice',
  with: 'Sabés qué revisar antes de firmar'
}, {
  situation: 'Presentar a tu hijo ante clubes',
  without: 'Sin estructura ni herramientas',
  with: 'CV deportivo profesional armado'
}];